<template>
    <div @mouseleave="mouc">
        <template v-if="currentPath == '/home'">
            <div style="position: relative;width: 100%;">
                <div class="top-0 left-0 right-0 z-50 absolute" style="height:80px;width: 100%;">
                    <div class="mx-auto h-full flex items-center" style="width:1300px;justify-content:space-between;">
                        <div class="flex items-center" v-if="$isxj">
                            <a href="/home" @click.prevent="to('/home')" class="flex items-center">
                                <img style="height: 50px;width: 168.5px;" :src="logob" :alt="siteConfig.title" />
                                <span class="ml-2 text-2xl hidden sm:block text-shuhei text-primary cprimary font-bold"
                                    style="font-size: 25px;color:#fff;"><span
                                        style="font-size: 22px;font-weight: 200;position: relative;top: -2px;color: #868686;margin: 0px 2px;">|</span>
                                    腾讯授权服务商</span>
                            </a>
                        </div>
                        <div v-else style="">
                            <img style="width: 400px;" :src="logoc" :alt="siteConfig.title" />
                        </div>
                        <div style="display: flex;align-items: center;">
                            <nav>
                                <ul class="flex" @mouseenter="istrue = false" @mouseleave="istrue = true">
                                    <template v-for="(item, i) in navItems">
                                        <li v-if="item.sub" class="header-li-item nav-has-sub" :class="{ 'asdzxcas': bindex == i }"
                                            style="height: 80px;position:relative;">
                                            <a class="clickbutton" style="color:#fff;" :href="item.href"
                                                @click.prevent="to(item.href)" @mouseenter="mou(i)"
                                                @mouseleave="bindex = -1"
                                                :class="`header-nav-item ${currentPath === item.href ? 'active' : ''}`">
                                                {{ item.text }}
                                            </a>
                                            <transition name="asdzxc">
                                                <div v-show="navItems[1].isshow" class="nav-agent-sub" @mouseenter="mou(1)" @mouseleave="moub(1)">
                                                <a href="/WorkBuddy" @click.prevent="to('/WorkBuddy')">WorkBuddy<small>你的企业 AI 工作台</small></a>
                                                <a href="/AIAgentCodeBuddy" @click.prevent="to('/AIAgentCodeBuddy')">CodeBuddy<small>腾讯云 AI 编程助手</small></a>
                                                <a href="/Aiagentaipas" @click.prevent="to('/Aiagentaipas')">AI智能体中台<small>企业专属的大模型应用底座</small></a>
                                                <a href="/AIAgentADP" @click.prevent="to('/AIAgentADP')">腾讯云智能体开发平台 ADP<small>企业原生智能体底座 · AgentOps</small></a>
                                                <a href="/AIAgentTokenHub" @click.prevent="to('/AIAgentTokenHub')">大模型服务平台 TokenHub<small>统一的大模型服务入口</small></a>
                                                </div>
                                            </transition>
                                        </li>
                                        <li v-else class="header-li-item" :class="{ 'asdzxcas': bindex == i }"
                                            style="height: 80px;">
                                            <a class="clickbutton" style="color:#fff;" :href="item.href"
                                                @click.prevent="to(item.href)" @mouseenter="mou(i)"
                                                @mouseleave="bindex = -1"
                                                :class="`header-nav-item ${currentPath === item.href ? 'active' : ''}`">
                                                {{ item.text }}
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="currentPath != '/home'">
            <div style="height:80px;"></div>
            <div style="position: relative;width: 100%;">
                <div class="top-0 left-0 right-0 z-50 bg-white shadow-md fixed" style="height:80px;width: 100%;">
                    <!-- :class="{ 'containerb': currentPath != '/home' }" -->
                    <div class="mx-auto h-full flex items-center" style="width:1300px;justify-content:space-between;">
                        <div class="flex items-center" v-if="$isxj">
                            <a href="/home" @click.prevent="to('/home')" class="flex items-center">
                                <img style="height: 50px;width: 168.5px;" :src="logo" :alt="siteConfig.title" />
                                <span class="ml-2 text-2xl hidden sm:block text-shuhei text-primary cprimary font-bold"
                                    style="font-size: 25px;"><span
                                        style="font-size: 22px;font-weight: 200;position: relative;top: -2px;color: #868686;margin: 0px 2px;">|</span>
                                    腾讯授权服务商</span>
                            </a>
                        </div>
                        <div v-else style="">
                            <img style="width: 400px;" :src="logod" :alt="siteConfig.title" />
                        </div>
                        <div style="display: flex;align-items: center;">
                            <nav>
                                <ul class="flex" @mouseenter="istrue = false" @mouseleave="istrue = true">
                                    <template v-for="(item, i) in navItems">
                                        <li v-if="item.sub" class="header-li-item nav-has-sub" :class="{ 'asdzxcas': bindex == i }"
                                            :style="'height: 80px;position:relative;border-bottom: ' + ((currentPath == item.href && istrue && bindex == -1) ? 3 : 0) + 'px solid #1e66d1;'">
                                            <a class="clickbutton" :href="item.href" @click.prevent="to(item.href)"
                                                @mouseenter="mou(i)" @mouseleave="bindex = -1"
                                                :class="`header-nav-item ${currentPath === item.href ? 'active' : ''}`">
                                                {{ item.text }}
                                            </a>
                                            <transition name="asdzxc">
                                                <div v-show="navItems[1].isshow" class="nav-agent-sub" @mouseenter="mou(1)" @mouseleave="moub(1)">
                                                <a href="/WorkBuddy" @click.prevent="to('/WorkBuddy')">WorkBuddy<small>你的企业 AI 工作台</small></a>
                                                <a href="/AIAgentCodeBuddy" @click.prevent="to('/AIAgentCodeBuddy')">CodeBuddy<small>腾讯云 AI 编程助手</small></a>
                                                <a href="/Aiagentaipas" @click.prevent="to('/Aiagentaipas')">AI智能体中台<small>企业专属的大模型应用底座</small></a>
                                                <a href="/AIAgentADP" @click.prevent="to('/AIAgentADP')">腾讯云智能体开发平台 ADP<small>企业原生智能体底座 · AgentOps</small></a>
                                                <a href="/AIAgentTokenHub" @click.prevent="to('/AIAgentTokenHub')">大模型服务平台 TokenHub<small>统一的大模型服务入口</small></a>
                                                </div>
                                            </transition>
                                        </li>
                                        <li v-else class="header-li-item" :class="{ 'asdzxcas': bindex == i }"
                                            :style="'height: 80px;border-bottom: ' + ((currentPath == item.href && istrue && bindex == -1) ? 3 : 0) + 'px solid #1e66d1;'">
                                            <a class="clickbutton" :href="item.href" @click.prevent="to(item.href)"
                                                @mouseenter="mou(i)" @mouseleave="bindex = -1"
                                                :class="`header-nav-item ${currentPath === item.href ? 'active' : ''}`">
                                                {{ item.text }}
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                            </nav>
                            <!-- <div style="display: flex;justify-items: center;margin-left: 20px;" v-if="currentPath == '/home'">
                            <div style="width: 150px;height: 36px;font-size: 16px;background: #fff;border-radius: 50px;display: flex;align-items: center;justify-content: center;cursor: pointer;">
                            <div><img src="../assets/logo/dianhua.png" style="height: 20px;"></div>
                            <div>027-67536585</div>
                        </div>
                            <div @click="to('/contactForm')"
                                style="width: 90px;height: 36px;color: #fff;font-size: 16px;background: #f18500;border-radius: 50px;text-align: center;line-height: 36px;margin-left: 10px;cursor: pointer;">
                                联系我们</div>
                        </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- 超级菜单常驻 DOM（v-show），爬虫才能抓到里面的产品/应用/方案链接。
             刻意不加 transition：0.5s 淡出期间旧分区仍占高度，切换菜单时
             两个分区的面板会同时出现在屏幕上，看起来就是"下拉叠在一起" -->
        <div id="hmenu"
                v-show="navItems[2].isshow || navItems[4].isshow || navItems[5].isshow || navItems[6].isshow"
                style="background: #fff;position: fixed;top: 80px;width: 100%;z-index: 999999;box-shadow:0 14px 34px rgba(20, 45, 90, .16);"
                :style="currentPath != '/home' ? 'border-top: 1px solid #cccccc;' : ''">
                <div style="width: 1200px;margin: 0px auto;">
                    <div v-show="navItems[2].isshow" class="hmenu-sec" @mouseenter="mou(2)" @mouseleave="moub(2)"
                        style="flex-wrap: wrap;padding:50px 0px;">
                        <a :href="menuHref('AIMenu', x.title)" @click.prevent="tob('AIMenu', x.title)" v-for="(x, i) in AImenus"
                            style="margin:10px 0px;width: 240px;display: flex;">
                            <div class="pmenu"
                                style="padding:10px 15px; cursor: pointer;border-radius: 10px;display: flex;align-items: center;">
                                <div><img :alt="x.title" style="height: 26px;width: 26px;" :src="x.icon"></div>
                                <div style="font-size: 14px;margin-left: 10px;">{{ x.title }}</div>
                            </div>
                        </a>
                    </div>
                    <div v-show="navItems[4].isshow" class="hmenu-sec" @mouseenter="mou(4)" @mouseleave="moub(4)"
                        style="padding:25px 0px;">
                        <div v-for="x in pmenu" style="font-size: 14px;" v-if="x.name != '自研产品'">
                            <div
                                style="font-weight: bold;color: #333;margin-top: 10px;height: 20px;width: 158px;line-height: 20px;padding-left: 12px;border-left: 3px solid #1e66d1;margin-bottom: 20px;">
                                {{ x.name }}</div>
                            <a :href="menuHref('product', z.ID)" @click.prevent="tob('product', z.ID)" class="pmenu"
                                style="color: #666;margin-top: 10px;display: block;height: 36px;min-width: 140px;line-height: 36px;padding: 0px 15px;cursor: pointer;border-radius: 5px;"
                                v-for="z in x.children">{{ z.name }}</a>
                        </div>
                    </div>
                    <div v-show="navItems[5].isshow" class="hmenu-sec" @mouseenter="mou(5)" @mouseleave="moub(5)"
                        style="padding:25px 0px;">
                        <div v-for="x in apps" style="font-size: 14px;">
                            <div style="display: flex;align-items: center;margin-bottom: 0px;">
                                <div style="background: #35a9b1;border-radius: 10px;"><img :alt="x.name"
                                        style="height: 40px;width: 40px;" :src="action + x.logosrc"></div>
                                <div style="font-weight: bold;color: #333;margin-left: 20px;">
                                    {{ x.name }}
                                </div>
                            </div>
                            <div style="display: flex;flex-wrap: wrap;flex-direction: column;height: 330px;margin-left: 20px;"
                                :class="{ 'widthaaa': x.children.length > 7 }">
                                <a class="pmenu" :href="menuHref('app', z.ID)" @click.prevent="tob('app', z.ID)"
                                    style="color: #666;margin-top: 10px;display: block;height: 36px;line-height: 36px;margin-left:20px;padding: 0px 20px; cursor: pointer;border-radius: 5px;"
                                    v-for="z in x.children">{{ z.name }}</a>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="navItems[5].isshow" @mouseenter="mou(5)" @mouseleave="moub(5)"
                        style="display: flex;justify-content: left;flex-wrap: wrap;padding:50px 0px;width: 960px;margin: 0px auto;">
                        <div @click="tob('WorkBuddy', i)" v-for="(x, i) in WBmenus"
                            style="margin:10px 0px;width: 240px;display: flex;">
                            <div class="pmenu"
                                style="padding:10px 15px; cursor: pointer;border-radius: 10px;display: flex;align-items: center;">
                                <div><img style="height: 26px;width: 26px;" :src="x.icon"></div>
                                <div style="font-size: 14px;margin-left: 10px;">{{ x.title }}</div>
                            </div>
                        </div>
                    </div> -->
                    <div v-show="navItems[6].isshow" class="hmenu-sec" @mouseenter="mou(6)" @mouseleave="moub(6)"
                        style="flex-wrap: wrap;padding:25px 0px;">
                        <a class="pmenu" :href="menuHref('solution', x.ID, i)" @click.prevent="tob('solution', x.ID, i)" v-for="(x, i) in menus"
                            style="display: flex;align-items: center;margin:10px 0px;width: 260px;padding:10px 0px;padding-left:50px;cursor: pointer;border-radius: 10px;">
                            <div><img :alt="x.name + '行业解决方案'" style="height: 22px;width: 22px;" :src="imgs[i]"></div>
                            <div style="font-size: 14px;margin-left: 10px;">{{ x.name }}行业解决方案</div>
                        </a>
                    </div>
                </div>
        </div>
        <keep-alive :exclude="'handlePrint'">
            <router-view />
        </keep-alive>
        <!-- :style="{ 'height': $isxj ? '160px' : '140px' }" -->
        <div class="bg-primary">
            <div class="relative" style="height: 200px;background: #29313f;">
                <!-- <img :src="siteConfig.footer.background" class="w-full h-full object-cover top-0 left-0 absolute"
                    alt="footer background" style="height: 180px;" /> -->
                <div class="relative text-white py-2">
                    <div class="containerb" style="margin: 0px auto;margin-top: 15px;">
                        <!-- 页脚全站导航：给爬虫提供站内入口，避免只能依赖 sitemap 进站 -->
                        <nav class="footer-nav" aria-label="网站导航">
                            <a v-for="item in navItems" :key="item.href" :href="item.href"
                                @click.prevent="to(item.href)">{{ item.text }}</a>
                            <a href="/contactForm" @click.prevent="to('/contactForm')">联系我们</a>
                        </nav>
                        <!-- <nav class="flex items-center flex-wrap py-4 px-4">
                            <span class="text-lg font-bold mr-4">产品</span>
                            <ul class="flex text-white/60" style="font-size: 14px;margin-left: 50px;">
                                <template v-for="(item, i) in list">
                                    <li class="mr-6">
                                        <a href="#" onclick="return false">{{ item }}</a>
                                    </li>
                                </template>
                            </ul>
                        </nav> -->
                        <!-- <div style="background: #666;height: 1px;" class="w-full bg-white/20 my-2"></div> -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 py-4">
                            <div>
                                <p class="text-2xl">
                                    {{ siteConfig.slogan }}
                                </p>
                                <div class="text-white bg-primary px-2 py-1 rounded-md text-xs mt-4 w-max bprimary">
                                    {{ siteConfig.subTitle }}
                                </div>
                            </div>
                            <div>
                                <div class="text-xl mb-4" style="font-size: 16px;font-weight: bold;">
                                    {{ siteConfig.title }}
                                </div>
                                <!-- :class="{ 'cyaddress': !$isxj }" -->
                                <p class="text-white/60 text-sm" style="opacity: 0.65;">
                                    {{ siteConfig.contact.address }}
                                </p>
                                <p class="text-white/60 text-sm"
                                    style="margin-bottom: 10px;margin-top: 16px;opacity: 0.65;">
                                    咨询电话：{{ siteConfig.contact.phone }}
                                </p>
                                <!-- <label @click="to('/contactForm')"
                                    style="font-size: 14px;color: #87898d;margin-top: 10px;border: 1px solid #87898d;padding:3px 10px;border-radius: 5px;cursor: pointer;">
                                    联系我们
                                </label> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full" style="background-color: #29313f;text-align: center;color: #87898d;">
                <div style="display: inline-block;font-size: 14px;height: 60px;line-height: 60px;color: #87898d;"
                    class="containerb flex items-center justify-center text-white flex-col md:flex-row">
                    <span class="mr-4">
                        {{ siteConfig.footer.copyright }}
                    </span>
                    <span class="mr-4">
                        <a onclick="return false" :href="siteConfig.footer.icpLink">{{ siteConfig.footer.icp }}</a>
                    </span>
                    <span>
                        <a onclick="return false" :href="siteConfig.footer.gajLink">{{ siteConfig.footer.gaj }}</a>
                    </span>
                </div>
            </div>
        </div>
        <!-- box-shadow: rgb(0 0 0 / 50%) -5px 5px 20px 1px; -->
        <!-- box-shadow: rgb(125 125 125 / 50%) -1px 0px 10px 0px; -->
        <div v-if="iskefu">
            <div v-if="ispc"
                style="position: fixed;right: 55px;bottom: 186px;z-index: 99999999;display: flex;align-items: center;border-radius: 5px;border: 2px solid rgb(241 241 241);padding: 20px 20px;background: #fff;">
                <div v-if="$isxj"><img alt="企业微信客服二维码" src="../assets/home/kefu.png" style="width: 80px;"></div>
                <div v-else><img alt="企业微信客服二维码" src="../assets/home/kefuc.png" style="width: 80px;"></div>
                <div style="margin-left: 20px;">
                    <div style="font-size: 18px;">微信扫码</div>
                    <div style="font-size: 14px;color: #999;margin-top: 5px;">联系企业微信客服</div>
                </div>
            </div>
            <div v-if="!ispc" :style="{ bottom: ispc ? '186px' : 'calc(50% - 114px)' }"
                style="position: fixed;right: 55px;z-index: 99999999;display: flex;align-items: center;border-radius: 5px;border: 2px solid rgb(241 241 241);padding: 20px 20px;background: #fff;">
                <div v-if="$isxj"><img alt="企业微信客服二维码" src="../assets/home/kefu.png" style="width: 220px;"></div>
                <div v-else><img alt="企业微信客服二维码" src="../assets/home/kefuc.png" style="width: 220px;"></div>
                <div style="margin-left: 20px;">
                    <div style="font-size: 30px;">微信扫码</div>
                    <div style="font-size: 28px;color: #999;margin-top: 50px;">联系企业微信客服</div>
                </div>
            </div>
        </div>
        <div><img alt="企业微信客服二维码" src="../assets/home/kefub.png" class="kefub" @mouseenter="iskefu = true" @mouseleave="iskefu = false"
                :style="{ bottom: ispc ? '259px' : '50%' }"
                style="width: 50px;height: 50px;position: fixed;right: 0px;cursor: pointer;z-index: 99999999;border-radius: 5px;">
        </div>
    </div>
</template>
<script>
import { getJsonTree } from '@/utils/index'
import { detailPath } from '@/utils/route-params'
export default {
    data() {
        return {
            ispc: true,
            action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
            logo: require("@/assets/logo.png"),
            logob: require("@/assets/logob.png"),
            logoc: require("@/assets/logoc.png"),
            logod: require("@/assets/logod.png"),
            currentPath: '/home',
            pmenu: [],
            apps: [],
            menus: [],
            WBmenus: [
                { icon: require("@/assets/hometo/nav1@2x.png"), title: '产品定位' },
                { icon: require("@/assets/hometo/nav2@2x.png"), title: '产品形态' },
                { icon: require("@/assets/hometo/nav3@2x.png"), title: '核心能力' },
                { icon: require("@/assets/hometo/nav4@2x.png"), title: '热门应用场景' },
                { icon: require("@/assets/hometo/nav5@2x.png"), title: '行业应用案例' },
                { icon: require("@/assets/hometo/nav6@2x.png"), title: '岗位价值' },
                { icon: require("@/assets/hometo/nav7@2x.png"), title: '产品版本与定价' },
            ],
            AImenus: [
                // { icon: require("@/assets/home/ai11@2x@2x.png"), title: 'AI智能体中台' },
                { icon: require("@/assets/home/ai11@2x@2xb.png"), title: 'AI会议纪要生成器' },
                { icon: require("@/assets/home/ai5@2x.png"), title: 'AI舆情监测' },
                { icon: require("@/assets/home/ai@2x.png"), title: '智慧财务服务助手' },
                { icon: require("@/assets/home/ai1@2x.png"), title: 'AI知识库' },
                { icon: require("@/assets/home/ai2@2x.png"), title: 'AI智能客服' },
                { icon: require("@/assets/home/ai4@2x.png"), title: '智能安防AI预警' },
                { icon: require("@/assets/home/ai6@2x.png"), title: '智能运维接管' },
                { icon: require("@/assets/home/ai7@2x.png"), title: '网络日志智能报表' },
                { icon: require("@/assets/home/ai8@2x.png"), title: '招投标助手' },
                { icon: require("@/assets/home/ai9@2x.png"), title: '施工技术方案智能审核平台' }
            ],
            istrue: true,
            iskefu: false,
            bindex: -1,
            navItems: [
                { text: '首页', href: '/home' },
                { text: 'AI智能体', href: '/AIAgentMain', isshow: false, sub: true },
                { text: 'AI应用定制', href: '/AIMenu', isshow: false },
                { text: 'FDE落地服务', href: '/fdeService', isshow: false },
                { text: '标准产品', href: '/product', isshow: false },
                { text: '定制应用', href: '/app', isshow: false },
                // { text: 'WorkBuddy', href: '/WorkBuddy', isshow: false },
                { text: '行业AI解决方案', href: '/solution', isshow: false },
                { text: '客户案例', href: '/crmcase' },
                { text: '关于我们', href: '/aboutus' },
            ],
            // list: [
            //     "腾讯会议",
            //     "腾讯云",
            //     "企业微信",
            //     "腾讯乐享",
            //     "电子签",
            //     "腾讯文档",
            //     "企业网盘",
            //     "腾讯问卷",
            //     "腾讯微卡",
            //     "腾讯云联络中心",
            // ],
            siteConfig: {
                // 标题
                title: "武汉讯捷信息技术有限公司",
                // 图标
                icon: require("@/assets/logo.png"),
                // 副标题
                subTitle: "腾讯授权服务商",
                // 描述
                // description:
                //     "讯捷官方网站 - 我们是一家面向全国提供IT解决方案与服务的公司。 提供腾讯企业产品落地方案，为客户打通各种应用场景，提供咨询、规划、项目开发、系统集成、实施建设、运营推广、售后维护的综合性解决方案提供商。 ",
                // // 关键词
                // keywords:
                //     "讯捷, 技术服务, 软件开发, 数字化转型, 腾讯企业产品, 解决方案, 系统集成, 实施建设, 运营推广, 售后维护",
                // 口号
                slogan: "平台 + 产品 + 服务 = 用户价值",
                // 联系方式
                contact: {
                    phone: "027-87860160",
                    address: "公司地址：湖北省武汉市洪山区书城路维佳创意大厦西区",
                },
                footer: {
                    background: require("@/assets/images/footer.jpg"),
                    copyright: "武汉讯捷信息技术有限公司 版权所有",
                    icp: "鄂ICP备14010542号-1",
                    icpLink: "https://beian.miit.gov.cn/",
                    gajLink:
                        "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010602000117",
                    gaj: "鄂公网安备 42011102002084号",
                }
            },
            imgs: [require("@/assets/logo/tub1.png"), require("@/assets/logo/tub2.png"), require("@/assets/logo/tub3.png"), require("@/assets/logo/tub4.png"), require("@/assets/logo/tub5.png"), require("@/assets/logo/tub6.png"), require("@/assets/logo/tub7.png"), require("@/assets/logo/tub8.png")]
        }
    },
    created() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.ispc = false
        }
        if (!this.$isxj) {
            this.siteConfig.title = '北京畅邮空间信息技术有限公司'
            this.siteConfig.contact.address = '公司地址：北京市丰台区马家堡西路15号时代风帆大厦'
            this.siteConfig.contact.phone = '400-056-0650'
            this.siteConfig.footer.icp = '京ICP备16025940号'
            this.siteConfig.footer.gaj = ''
            this.siteConfig.footer.copyright = '北京畅邮空间信息技术有限公司 版权所有'
        }
        this.syncCurrentPath()
        //产品
        this.$http('/Product/GetTypeData').then(x => {
            if (x.data.length > 0) {
                var data = getJsonTree(x.data, '', 'pid')
                data.forEach(z => {
                    z.children.forEach(w => {
                        if (w.name == '不要删') w.name = '自研产品'
                        this.pmenu.push(w)
                    })
                })
            }
        })
        //应用
        this.$http('/App/GetTypeData').then(x => {
            if (x.data.length > 0) {
                var data = getJsonTree(x.data, '', 'pid')
                this.apps = data
            }
        })
        //解决方案
        this.$http('/Plan/GetTypeData').then(x => {
            if (x.data.length > 0) {
                this.menus = x.data.filter(z => z.name != '央企' && z.name != '国企')
            }
        })
    },
    methods: {
        // 由当前路由推导出「栏目段」，导航高亮与首页透明导航都依赖它
        // 详情页（/product/xxx）归一到栏目（/product），根路径归一到 /home
        syncCurrentPath() {
            var seg = '/' + (this.$route.path.split('/')[1] || '')
            if (seg === '/') seg = '/home'
            // AI智能体子页面统一高亮 AI智能体菜单
            const aiSubPaths = ['/AIAgentADP', '/AIAgentTokenHub', '/AIAgentCodeBuddy', '/AIAgentMain', '/AI', '/WorkBuddy', '/Aiagentaipas']
            this.currentPath = aiSubPaths.includes(seg) ? '/AIAgentMain' : seg
            this.bindex = -1
        },
        mou(i) {
            this.navItems.forEach(x => x.isshow = false)
            // if (this.currentPath != this.navItems[i].href)
            this.navItems[i].isshow = true
            this.bindex = i
        },
        moub(i) {
            this.navItems[i].isshow = false
            this.bindex = -1
        },
        mouc() {
            this.navItems.forEach(x => x.isshow = false)
        },
        to(path) {
            this.navItems.forEach(x => x.isshow = false)
            // 原实现把 /product、/app、/solution 排除在跳转之外，导致三个主菜单点击无响应；
            // 路径路由已支持可选参数，直接 push 栏目路径即可回到列表首项
            if (this.$route.path === path) return
            this.currentPath = path
            this.$router.push(path)
        },
        // 供模板生成真实 href：下拉菜单里的链接需要出现在 HTML 中，爬虫才能抓到。
        // 参数拼装与 tob() 共用同一份逻辑，避免 href 与实际跳转到的地址不一致
        menuHref(name, ID, index) {
            var key = name == 'solution' ? index : (name == 'WorkBuddy' ? ID + 1 : ID)
            return detailPath('/' + name, key)
        },
        tob(name, ID, index) {
            this.navItems.forEach(x => x.isshow = false)
            // 统一走路径参数：/product/{id}、/app/{id}、/AIMenu/{title}、/solution/{index}、/WorkBuddy/{targetId}
            // 同栏目换详情由各组件的 $route 监听处理，不能整页 reload：
            // 那会把 SPA 变成整页刷新，滚动位置丢失，用户感觉像"点了卡住"
            this.$router.push(this.menuHref(name, ID, index))
        }
    },
    watch: {
        $route() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
            if (document.body) {
                document.body.scrollTo({
                    top: 0,
                    behavior: 'smooth' // 平滑滚动
                });
            }
            this.syncCurrentPath()
            // 跳转后必须收起所有下拉：否则菜单面板会盖在页面上，
            // 看起来像"点了没反应"，实际是被面板挡住
            this.navItems.forEach(x => x.isshow = false)
        }
    }
}
</script>
<style>
/* 页脚全站导航 */
.footer-nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 28px;
    padding: 12px 16px 0;
    font-size: 14px;
    line-height: 20px;
}

.footer-nav a {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    transition: color .2s;
}

.footer-nav a:hover {
    color: #fff;
}

@keyframes asdzxc {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.asdzxc-enter-active {
    animation: asdzxc 0.5s ease-in-out;
}

.asdzxc-leave-active {
    animation: asdzxc 0.5s ease-in-out reverse;
}

footer {
    --color-primary: #1e66d1;
}

.header-nav-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    font-size: 15px;
    transition: color 0.3s ease-in-out;
    cursor: pointer;
    padding: 0px 13px 0px 13px;
    margin: 0px 0px;
}

.header-nav-item:hover {
    color: var(--color-primary);
}

.header-nav-item.active {
    color: var(--color-primary);
    font-size: 15px;
    font-weight: bold;
}

/* 超级菜单的每个分区。
   display 必须由 class 提供，不能写在 style 里：
   v-show 隐藏靠内联 display:none，而静态 style 在每次重渲染时会被重新应用，
   会把 display:flex 又盖回去，导致所有分区同时显示、下拉叠成一片。 */
.hmenu-sec {
    display: flex;
    justify-content: space-around;
}

#hmenu .pmenu {
    border: 1px solid transparent;
}

#hmenu .pmenu:hover {
    border: 1px solid #1e66d1;
    color: #1e66d1;
    background: #edf3fb;
}

.header-li-item:hover {
    border-bottom: 3px solid #1e66d1 !important;
}

/* AI智能体下拉面板 —— 仿 sunjee-site .nav-submenu 样式 */
.nav-agent-sub {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    min-width: 268px;
    background: #fff;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 14px 34px rgba(20, 45, 90, .16);
    padding: 10px 0;
    z-index: 999999;
}

.nav-agent-sub a {
    display: block;
    padding: 11px 24px;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    white-space: nowrap;
    text-decoration: none;
    transition: background .18s ease, color .18s ease;
    cursor: pointer;
}

.nav-agent-sub a:hover {
    background: #f2f7ff;
    color: #1e66d1;
}

.nav-agent-sub a small {
    display: block;
    font-size: 12px;
    color: #9aa4b2;
    margin-top: 2px;
}

.asdzxcas {
    border-bottom: 3px solid #1e66d1 !important;
}

.kefub:hover {
    /* box-shadow:none !important; */
}

.cyaddress {
    margin-top: 25px;
}

.widthaaa {
    width: 250px;
}
</style>